import React, { Component } from "react";
import { AssetCard } from "@10x/dubai-rest-api/dist/property_registry/entity";
import { ENocMLookUp, ENocMLookupData, ENocMollakData, Mode } from "../../enocapi/entities";
import { normalizeENocRequest, populateENocMLookup } from "../../enocapi/services";
import { TabuProfile } from "@10x/sso/TabuProfile";
import { navigate } from "@my-dld/utils/StoreUtils";
import Popup from "../Popup/Popup";
import { JQModal } from "../Popup/Utils";
import { cancelNOCRequest, getENocMollakRequest } from "../../enocapi/api";
import { hideLoading, showLoading, showMessage } from "@my-dld/utils/UIUtils";
import Strings from "@my-dld/assets/strings";

interface Props {
	exception: any;
	tabuProperty: AssetCard;
	onDismiss: () => void;
}

interface State {
	nocID: number;
}

class RejectionActions extends Component<Props, State> {
	constructor( props: Props ) {
		super( props );
		const excep = props.exception;
		const nocID = excep.response && excep.response.requestObjectId
		&& excep.response.requestObjectId !== "" ? excep.response.requestObjectId : undefined;
		this.state = {
			nocID: nocID,
		};
	}

	dismiss = () => {
		JQModal( "rejection_request" ).hide();
		this.props.onDismiss();
	};

	render() {
		const excep = this.props.exception;
		return (
			<Popup autoOpenMount={ true } showIcon={ false } id={ "rejection_request" } onDismiss={ this.dismiss } modalBodyContainer="">
				<div className="modal-body">
					<p className="mt-2">{ excep.message }</p>
				</div>
				<div className="modal-footer d-flex justify-content-between">
					<button
						type="button" className="btn btn-grey" data-bs-dismiss="modal" aria-label="Close"
						onClick={ this.dismiss }>{ Strings.close }
					</button>
					<div>
						<button type="button" className="btn btn_1" onClick={ this.createNewRequest }>{ Strings.create_new_request }</button>
						<button type="button" className="btn btn_1 ms-2" onClick={ this.modifyENocRequest }>{ Strings.modify }</button>
					</div>
				</div>
			</Popup>
		);
	}

	createNewRequest = () => {
		const { nocID } = this.state;
		const { tabuProperty } = this.props;
		if ( nocID ) {
			showLoading();
			cancelNOCRequest( nocID ).then( resp => {
				this.dismiss();
				createNewENocRequest( tabuProperty );
			} ).catch( exp => {
				hideLoading();
				this.dismiss();
				showMessage( exp.message );
			} );
		} else {
			this.dismiss();
		}
	};

	modifyENocRequest = () => {
		const { nocID } = this.state;
		getENocMollakRequest( nocID + "" ).then( ( resp: any ) => {
			this.dismiss();
			hideLoading();
			if ( resp ) {
				let returnData = normalizeENocRequest( resp, Mode.EDIT );
				navigate( `/mydld/enocm/${ returnData.mollakPropertyId }`, undefined, {
					property: returnData.property,
					eNOCModel: returnData,
					buyers: returnData.buyerInfo,
				} );
			}
		} ).catch( exception => {
			hideLoading();
			this.dismiss();
			showMessage( exception.message );
		} );
	};
}

export default RejectionActions;

export function createNewENocRequest( tabuProperty: AssetCard ) {
	let eNOCModel: ENocMollakData = {};
	populateENocMLookup( ENocMLookUp.NOC_REQUESTER_TYPE, undefined, ( data ) => {
		hideLoading();
		const ownerId = TabuProfile.getParticipantNumber();
		const tp = TabuProfile.getProfile();
		if ( data ) {
			const p = data.find( ( val: ENocMLookupData ) => val.identity === 1 );
			let requestInfo = {
				requestType: p,
				owner: {
					identity: ownerId,
					nameEn: tp?.nameEn,
					nameAr: tp?.nameAr,
				},
				name: {
					englishName: tp?.nameEn,
					arabicName: tp?.nameAr,
				},
				contact: {
					email: tp?.emailAddress,
					mobile: tp?.phoneNumber,
				},
			};
			eNOCModel.mollakPropertyId = Number( tabuProperty.tabuPropertyId );
			eNOCModel.requestInfo = requestInfo;
			eNOCModel.mode = Mode.CREATE;
			eNOCModel.totalArea = tabuProperty.size.squareMeter;
			navigate( `/mydld/enocm/${ tabuProperty.tabuPropertyId }`, undefined, {
				property: tabuProperty,
				eNOCModel: eNOCModel,
			} );
		}
	} );
}
